import moment from "moment";
import { TrashCan } from "@carbon/icons-react";

import {
  Badge,
  OverflowMenuDropDown,
  OverflowMenuDropDownItem,
} from "../../components";
import { IViewBankAccount, StatusColors } from "../../interfaces-and-types";
import { truncateStringWithEllipsis } from "../../utils";

import { countries, currencies } from "../../constants";
import { appConfig } from "../../configs";

export const bankAccountsDisplayFormatter = (item: IViewBankAccount) => {
  const statusIndicator: { statusText: string; statusType: StatusColors } =
    !item.is_disabled
      ? { statusText: "Active", statusType: "success" }
      : { statusText: "Disabled", statusType: "secondary" };

  const swAppCountry = countries
    .find(
      (grp) =>
        grp.options.find((ctry) => ctry.value === item.country) !== undefined
    )
    ?.options.find((ctry) => ctry.value === item.country);

  // TODO: add a global context with supported countries and currencies
  // const currency = swAppSupportedCurrencies.find((cur) => cur.value === item.currency);
  const currency = currencies.find((cur) => cur.value === item.currency);

  return {
    ...item,
    country_name: swAppCountry?.text,
    currency: currency?.text,
    account_name: (
      <div className="pt-5 pb-5">
        <strong>{item.account_name}</strong>
        <br />
        <div className="mt-5">
          {item.is_primary_account_number ? (
            <Badge text={"Primary Account"} statusColor={"teal"} />
          ) : item.is_set_as_primary_requested &&
            !item.is_switch_app_verified ? (
            <Badge
              text={"Primary: Verification Pending"}
              hideIndicator
              statusColor={"warning"}
            />
          ) : null}
        </div>
      </div>
    ),
    payout_tags: (
      <div className="pt-5 pb-5 tags-container">
        {item.bank_account_tags.map((tag, tagInd) => (
          <div className="">
            <Badge
              key={`${tag.id}-${tagInd}`}
              text={
                truncateStringWithEllipsis(tag.tag_name, 30) || tag.tag_name
              }
              title={`${tag.tag_name}${
                tag.description ? `: ${tag.description}` : ""
              }`}
              hideIndicator
              statusColor="teal"
              className="delete-tag--badge"
            />

            <span
              className="delete-tag--indicator text-danger font-ctm--bold"
              title="Delete Bank Account Tag"
              onClick={() =>
                item.openDeleteAccountTagModal &&
                item.openDeleteAccountTagModal(tag.id)
              }
            >
              <TrashCan className="" />
              {/* &times; */}
            </span>

            {/* Display an add button after the last tag in the list */}
            {tagInd !== 0 ? null : (
              // {tagInd !== item.bank_account_tags.length - 1 ? null : (
              <span
                className="add-tag--indicator text-primary font-ctm--bold"
                title="Add Bank Account Tag"
                onClick={() =>
                  item.openAppendAccountTagModal &&
                  item.openAppendAccountTagModal(item.id)
                }
              >
                +
              </span>
            )}
          </div>
        ))}

        {/* Also display add button if no tags present at all */}
        {item.bank_account_tags.length ? null : (
          <span
            className="add-tag--indicator text-primary font-ctm--bold"
            title="Add Bank Account Tag"
            onClick={() =>
              item.openAppendAccountTagModal &&
              item.openAppendAccountTagModal(item.id)
            }
          >
            +
          </span>
        )}
      </div>
    ),
    account_number: <strong>{item.account_number}</strong>,
    bank_name: (
      <span title={item.bank_name}>
        {truncateStringWithEllipsis(item.bank_name, 15)}
      </span>
    ),
    status: (
      <Badge
        text={statusIndicator.statusText}
        statusColor={statusIndicator.statusType}
      />
    ),
    settles_to: (
      <Badge
        text={item.settles_to_wallet ? "WALLET" : "BANK"}
        statusColor={item.settles_to_wallet ? "success" : "primary"}
        // hideIndicator
      />
    ),
    created_at: (
      <span className="date--oneline">
        {moment(item.created_at).format(appConfig.dateTimeFormat)}
      </span>
    ),
    more: (
      <OverflowMenuDropDown
        focusTrap={false}
        data-floating-menu-container
        size="sm"
        flipped
      >
        {!item.is_primary_account_number &&
        !item.is_set_as_primary_requested ? (
          <OverflowMenuDropDownItem
            index={1}
            itemText="Set As Primary Account"
            onClick={item.setAsPrimaryAccount}
          />
        ) : null}
        <OverflowMenuDropDownItem
          index={2}
          itemText={`Settle To ${item.settles_to_wallet ? "BANK" : "WALLET"}`}
          onClick={item.toggleSettleToWalletOrBank}
        />
        <OverflowMenuDropDownItem
          index={3}
          itemText="Add Bank Account Tag"
          onClick={() =>
            item.openAppendAccountTagModal &&
            item.openAppendAccountTagModal(item.id)
          }
        />
        <OverflowMenuDropDownItem
          index={4}
          isDelete
          hasDivider
          itemText="Remove Account"
          onClick={item.openDeleteModal}
        />
      </OverflowMenuDropDown>
    ),
  };
};
